import { StateOrName, StateParams, StateService } from "@uirouter/angularjs";
import { IOnInit, IScope } from "angular";
import { IFieldArray } from "AngularFormly";
import { FormViewController } from "../../../../../../app/records/forms/formView/controller";
import _ from "lodash";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../../../app/records/server/serverUtility";

import {
  FormViewService,
  vsName as FormViewServiceName,
} from "../../../../../../app/records/forms/formView/service";
import fieldHelpers from "../../../../../../app/ui-formly/fieldHelpers";
import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../../../../app/records/forms/formly/fieldConfigurationHelpers";
import {
  RecordsUtilsService,
  vsName as RecordsUtilsServiceName,
} from "../../../../../../app/records/utils";
import { ServiceResponse } from "../../../../../records/server/query";
import { Machine } from "../../../../../machines/shared/models/machine";
import { MachineConfiguration } from "../../../../../machines/shared/models/machineConfiguration";

export class DepreciationEditController implements IOnInit {
  static $inject = [
    FormViewServiceName,
    "$state",
    FieldConfigurationHelperServiceName,
    "$scope",
    RecordsUtilsServiceName,
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
  ];
  model: any;
  formFields!: IFieldArray;
  defaultSetting!: any;
  depreciation!: any;
  machine!: Machine<MachineConfiguration>;
  isMachineParam: boolean = false;
  machineId: string = "";
  machineDetails:any;

  returnSubmitState!: StateOrName;
  returnCancelState!: StateOrName;

  constructor(
    private readonly formViewService: FormViewService,
    private readonly $state: StateService,
    private readonly fieldConfigurationHelperService: FieldConfigurationHelperService,
    private readonly $scope: IScope,
    private readonly recordUtils: RecordsUtilsService,
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility
  ) {}

  private initializeFormFields() {
    const that = this;
    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          {
            key: "Machine",
            name: "Machine",
            type: "selectMachine",
            hide: !this.isMachineParam,
            templateOptions: {
              label: "Machine",
              required: this.isMachineParam,
              machineQuery: this.slotTrakMachinesServer.machinesQuery,
            },
            watcher: {
              listener: async (
                field: any,
                newValue: any,
                oldValue: any,
                scope: any
              ) => {
                if (!_.isEmpty(newValue)) {
                  that.machineId = newValue.Id;
                  var depreciation = await that.getDepreciationDetail(
                    newValue.Id
                  );
                  that.model = that.mapModel(
                    depreciation,
                    that.defaultSetting,
                    newValue
                  );
                }
              },
            },
            formatters: [this.formatMachine],
          },
          {
            key: "UsefulLife",
            name: "UsefulLife",
            type: "input",
            templateOptions: {
              label: "Useful Life",
              required: true,
            },
          },

          {
            key: "DepreciationMethod",
            name: "DepreciationMethod",
            type: "select",
            templateOptions: {
              label: "Depreciation Method",
              options: [
                {
                  label: "Straight Line",
                  value: "StraightLine",
                },
                {
                  label: "Double Declining Balance",
                  value: "DoubleDecliningBalance",
                },
                {
                  label: "Sum Of The Years Digits",
                  value: "SumOfTheYearsDigits",
                },
              ],
              required: true,
              labelProp: "label",
              valueProp: "value",
            },
          },
          fieldHelpers.simpleDateField({
            key: "UsefulLifeStartDate",
            name: "UsefulLifeStartDate",
            label: "Useful Life Start Date",
            required: true,
          }),
          fieldHelpers.simpleCurrencyField({
            key: "PurchaseCost",
            label: "Purchase Cost",
            name: "PurchaseCost",
            required: true,
          }),
          fieldHelpers.simpleCurrencyField({
            key: "SalvageValue",
            label: "Salvage Value",
            name: "SalvageValue",
            required: true,
          }),
        ],
        4
      ),
      fieldHelpers.headerField({
        headerText: "Notes",
        key: "NotesHeader",
      }),
      fieldHelpers.textAreaField({
        key: "Notes",
        name: "Notes",
        label: " ",
        rows: 5,
      }),
    ];
  }

  formatMachine(machine: any) {
    if (!machine) {
      return "";
    }

    return `${machine.SerialNumber}`;
  }

  $onInit(): void {
    this.machineId = this.$stateParams["machineId"];
    this.isMachineParam = this.machineId == undefined;
    var depreciation = this.depreciation;
    var defaultSetting = this.defaultSetting;
    this.model = this.mapModel(depreciation, defaultSetting, []);
    this.initializeFormFields();
  }

  mapModel(depreciation: any, defaultSetting: any, machine: any) {
    return {
      UsefulLife:
        depreciation?.UsefulLife == null
          ? defaultSetting?.UsefulLife
          : depreciation?.UsefulLife,
      DepreciationMethod:
        depreciation?.DepreciationMethod == null
          ? defaultSetting?.DepreciationMethod
          : depreciation?.DepreciationMethod,
      UsefulLifeStartDate: depreciation?.UsefulLifeStartDate,
      PurchaseCost: depreciation?.PurchaseCost,
      SalvageValue: depreciation?.SalvageValue,
      Notes: depreciation?.Notes,
      Machine: machine,
    };
  }

  async submit(formViewController: FormViewController): Promise<void> {
    await this.formViewService.submitForm({
      url: `/api/machines/Machine/${this.machineId}/depreciation`,
      formObject: this.model,
      formViewController,
      method: "post",
    });

    await this.$state.go(this.returnSubmitState, undefined, { reload: true });
  }

  async cancel() {
    await this.$state.go(this.returnCancelState);
  }

  async getDepreciationDetail(machineId: string) {
    return this.serverUtility
      .sendApiRequest({
        method: "get",
        url: `api/machines/Machine/${machineId}/depreciation`,
      })
      .then((r) => (<ServiceResponse<unknown>>r).Result);
  }
}
